<div class="camera-overlay" *ngIf="visible">
  <div class="camera-container">
    <!-- Header -->
    <div class="camera-header">
      <h3>Camera</h3>
      <button class="close-btn" (click)="close()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Preview Area -->
    <div class="preview-area">
      <div class="video-wrapper" [hidden]="capturedImage || capturedVideoUrl">
        <video #video autoplay playsinline muted [class.mirrored]="currentFacingMode === 'user'"></video>
        
        <!-- Recording UI -->
        <div class="recording-ui" *ngIf="isRecording">
          <div class="recording-indicator">
            <span class="dot"></span>
            <span class="timer">{{ getFormattedTime() }}</span>
          </div>
        </div>

        <div class="loading-overlay" *ngIf="isLoading">
          <div class="spinner"></div>
          <p>Initializing Camera...</p>
        </div>
        <div class="error-overlay" *ngIf="error">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
            stroke="#ff4d4f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <p>{{ error }}</p>
          <button (click)="startCamera()" class="retry-btn">Retry</button>
        </div>
      </div>

      <!-- Result Previews -->
      <div class="image-wrapper" *ngIf="capturedImage">
        <img [src]="capturedImage" alt="Captured frame" [class.mirrored]="currentFacingMode === 'user' && false" /> <!-- Canvas is already mirrored so image doesn't need it -->
      </div>

      <div class="video-preview-wrapper" *ngIf="capturedVideoUrl">
        <video #playbackVideo [src]="capturedVideoUrl" controls autoplay loop></video>
      </div>
    </div>

    <!-- Mode Switcher -->
    <div class="mode-switcher" *ngIf="!capturedImage && !capturedVideoUrl && !isRecording">
      <button [class.active]="captureMode === 'photo'" (click)="setMode('photo')">PHOTO</button>
      <button [class.active]="captureMode === 'video'" (click)="setMode('video')">VIDEO</button>
      <div class="active-pill" [style.transform]="captureMode === 'video' ? 'translateX(100%)' : 'translateX(0)'"></div>
    </div>

    <!-- Controls -->
    <div class="camera-controls">
      <!-- Capture Mode Controls -->
      <div class="capture-actions" *ngIf="!capturedImage && !capturedVideoUrl">
        <button class="shutter-btn" [class.recording]="isRecording" [class.video-mode]="captureMode === 'video'"
          (click)="handleShutterClick()" [disabled]="isLoading || !!error" [title]="isRecording ? 'Stop' : 'Capture'">
          <div class="shutter-inner"></div>
        </button>
        
        <button class="flip-camera-btn" *ngIf="!isRecording" (click)="toggleCamera()" title="Switch Camera">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="1 4 1 10 7 10"></polyline>
            <polyline points="23 20 23 14 17 14"></polyline>
            <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
          </svg>
        </button>
      </div>

      <!-- Preview Mode Controls -->
      <div class="review-actions" *ngIf="capturedImage || capturedVideoUrl">
        <button class="action-btn retake" (click)="retake()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"></polyline>
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
          </svg>
          Retake
        </button>
        <button class="action-btn use" (click)="useMedia()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          {{ captureMode === 'photo' ? 'Send Photo' : 'Send Video' }}
        </button>
      </div>
    </div>

    <!-- Hidden Canvas -->
    <canvas #canvas [style.display]="'none'"></canvas>
  </div>
</div>
